import {Box, BoxComponentProps} from 'reoil'
import React, {ReactNode} from 'react'
import {MdChevronRight} from 'react-icons/md'

interface CellProps {
  icon?: ReactNode
  iconColor?: string
  title: string
  desc?: string
  disabled?: boolean
}

const Cell: React.FC<BoxComponentProps & CellProps> = ({
  icon,
  title,
  desc,
  iconColor = 'primary',
  disabled,
  ...props
}) => {
  return (
    <Box
      className='Cell'
      p={3}
      fontSize={1}
      borderBox
      row
      center
      left
      border='divider'
      borderRadius={1}
      mb={2}
      opacity={disabled ? 0.4 : 1}
      pointer
      pointerEvents={disabled ? 'none' : 'unset'}
      {...props}>
      {icon && (
        <Box className='icon' color={iconColor}>
          {icon}
        </Box>
      )}
      <Box className='title' ml={2}>
        {title}
      </Box>
      {desc ? (
        <Box className='status' ml='auto' color='text.caption'>
          {desc}
        </Box>
      ) : (
        !disabled && (
          <Box className='arrow' ml='auto' color='text.caption'>
            <MdChevronRight />
          </Box>
        )
      )}
    </Box>
  )
}

export default Cell
